export const APP_ID = import.meta.env.VITE_APP_ID as string
// 去掉末尾斜杠，避免拼接 '/xxx' 时出现 '//xxx'
export const IMAGE_CDN = (import.meta.env.VITE_IMAGE_CDN as string).replace(/\/+$/, '')
// 官网图片实际走的域名（源站 img.gibbous.net）；IMAGE_CDN 只在这里取不到时用来重试。没配置时跟 IMAGE_CDN 一样
export const IMAGE_HOST = ((import.meta.env.VITE_IMAGE_HOST as string) || IMAGE_CDN).replace(/\/+$/, '')
export const BASE_URL = import.meta.env.VITE_APP_BASE_URL as string

export const TOKEN_KEY = 'gibbous-web-token'
export const SESSION_KEY = 'gibbous-web-session'
export const USER_ID_KEY = 'gibbous-web-uid'
export const USER_NAME_KEY = 'gibbous-web-uname'
export const USER_AVATAR_KEY = 'gibbous-web-avatar'
export const LANG_KEY = 'gibbous-web-lang'
export const LONGITUDE_KEY = 'gibbous-web-lng'
export const LATITUDE_KEY = 'gibbous-web-lat'
